<template>
  <div>
    <table class="w-100">
      <tr class="" v-for="log in logs">
        <td class="">
          <div class="activity-date">
            {{toReadableDate(new Date(log.timestamp))}}
          </div>
        </td>
        <td class="">
          <div class="activity-label">
            {{translated(log.action)}}
          </div>
        </td>
        <td class="">
          <div class="activity-info">
            <!--            <img class="img-fluid" src="@/assets/images/info-icon.svg" alt="Icon info">-->
            <i class="fal fa-info-circle"></i>
            <div class="activity-info-popup">
              <p class="mb-2 small">{{log.user.fullname}} &mdash; {{log.loglevel}}</p>
              <!--              <p class="mb-2 small">{{log.user.fullname}} (UID: {{log.user.id}}) </p>-->
              <p class="mb-2 small">{{log.ip}}</p>
              <p class="mb-0 small">{{parsedDate(log.created_at)}}</p>
            </div>
          </div>

        </td>
      </tr>
    </table>
    <div class="mt-3 pagination justify-content-between align-items-center">
      <a @click.prevent="setPage(activePage-1)"
         href="#"
         id="btn-page-prev"
         class="btn btn-primary">
        <i class="fas fa-chevron-left"></i>
      </a>
      <div id="page-number" class="text-green d-block">
        {{pagecount}}/{{pagemax}}
      </div>
      <a @click.prevent="setPage(activePage+1)"
         href="#"
         id="btn-page-next"
         class="btn btn-primary">
        <i class="fas fa-chevron-right"></i>
      </a>
    </div>
  </div>
</template>
<script>
  // import axios from "../axios-auth";
  import store from "../store/store";
  import moment from 'moment'

  export default {
    data() {
      return {
        managedUsers: [],
        logs: [],
        activePage: 1,
        resultCount: 0,
        resultsPerpage: 10,
        filter: null,
        start: 0,
      }
    },
    methods: {
      parsedDate(date){
        return moment(date).format('DD/MM/YYYY HH:MM:ss')
      },
      translated(action) {
        let t = null;
        switch (action) {
          case 'Saved filter':
            t = this.$t('message.saved_filter');
            break;
          case 'Created user':
            t = this.$t('message.created_user');
            break;
          case 'Created team':
            t = this.$t('message.created_team');
            break;
          case 'Added child':
            t = this.$t('message.added_child');
            break;
          case 'Edited child':
            t = this.$t('message.edited_child');
            break;
          case 'Posted new draft submission':
            t = this.$t('message.posted_draft');
            break;
          case 'Posted new final submission':
            t = this.$t('message.posted_final');
            break;
          case 'Reviewed submission':
            t = this.$t('message.reviewed_submission');
            break;
          case 'Edited company':
            t = this.$t('message.edited_company');
            break;
          case 'Edited user':
            t = this.$t('message.edited_user');
            break;
          case 'Edited team':
            t = this.$t('message.edited_team');
            break;
          case 'Added team member':
            t = this.$t('message.added_team_member');
            break;
          case 'Removed team member':
            t = this.$t('message.removed_team_member');
            break;
        }
        return t || action
      },
      setPage(pagenumber) {
        if (pagenumber > 0 && !(pagenumber > this.pagemax)) {
          let offset = this.resultsPerpage * (pagenumber - 1);
          this.start = offset;
          this.activePage = pagenumber
          this.getLogs();
        }
      },
      toReadableDate(m) {
        return moment(m).format('DD/MM/YYYY')
        // return m.getUTCDate() + '/' + (m.getUTCMonth() + 1) + '/' + m.getUTCFullYear()
      },
      getLogs() {
        let query = '/activitylogs';
        let cq = '/count';
        let type = '';
        if (this.type === 'user') { //todo AND operators voor filtering in strapi 3.1
          // type = '?loglevel_ncontains=HR&loglevel_ncontains=Manager'
          type = '?loglevel_ncontains=HR'
          // type = '?_where[0][loglevel_ncontains]=HR'+ '&_where[0][loglevel_ncontains]=Manager'
        }
        if (this.type === 'manager') {
          type = '?loglevel_ncontains=HR&loglevel_ncontains=User'
        }
        let q = '&_sort=timestamp:DESC';
        if (this.type === 'manager') {
          this.managedUsers.forEach(user => {
            q += '&user_in=' + user
          });
        } else {
          q += '&user=' + store.state.userId;
        }

        q += '&_start=' + this.start + '&_limit=' + this.resultsPerpage;
        this.axios.get(query + type + q).then(logs => logs.data)
          .then(res => {
            const data = res;
            this.logs = data;
          });
        this.axios.get(query + cq + type + q).then(logs => logs.data)
          .then(res => {
            const data = res;
            this.resultCount = data;
          })
      }
    },
    computed: {
      pagecount() {
        return this.activePage
      },
      pagemax() {
        return Math.ceil(this.resultCount / this.resultsPerpage)
      }
    },
    mounted() {
      let users = [];
      if (this.type === 'manager') {
        this.axios.get('/teams/myteam').then(res => {
          const teams = res.data;
          teams.forEach((team, ind) => {
            team.users.forEach(user => {
              users.push(user.id)
            })
          });
          this.managedUsers = users;
          this.getLogs();
        });
      } else {
        this.getLogs();
      }


    },
    props: {
      limit: {
        type: Number,
        default() {
          return 20
        }
      },
      type: {
        type: String,
        default() {
          return 'user'
        }
      }
    },
    created() {


    },
  }
</script>
<style>
  .activity-info {
    position: relative;
  }

  .activity-info .activity-info-popup {
    display: none;
    position: absolute;
    right: 30px;
    top: -10px;
    width: 200px;
    background-color: #000;
    z-index: 2;
    padding: 15px;
    color: #fff;
  }

  .activity-info-popup:after {
    content: '';
    position: absolute;
    display: block;
    right: -10px;
    top: 10px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid black;
  }

  .activity-info:hover .activity-info-popup {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Activitylog.vue